import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import {FuseProgressBarService} from '../../@fuse/components/progress-bar/progress-bar.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

    constructor(private progressBar: FuseProgressBarService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.progressBar.show();
        return next.handle(req).pipe(
            finalize(() => this.progressBar.hide())
        );
    }
}